var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagFaroeIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3044 16.0107L31.8643 13.9237C31.7713 13.2124 31.6318 12.5157 31.4489 11.8368H14.6087V0.0715332C13.8987 0.132658 13.2021 0.240721 12.5217 0.391596L9.73912 2.0976L8.34781 1.95716C7.61562 2.35666 6.91806 2.81166 6.26087 3.3166V11.8367H0.551181C0.368244 12.5156 0.228744 13.2123 0.135744 13.9237L0.695619 16.0107L0.135681 18.0976C0.228681 18.8089 0.368181 19.5057 0.551119 20.1845H6.26081V28.7047C6.91799 29.2097 7.61562 29.6646 8.34774 30.0641L10.4347 29.9237L12.5216 31.6297C13.2021 31.7805 13.8986 31.8885 14.6086 31.9497V20.1846H31.4487C31.6316 19.5057 31.7711 18.809 31.8641 18.0977L31.3044 16.0107Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9239H12.5218H12.5218V0.391113C11.0431 0.718988 9.64131 1.25043 8.34781 1.95624V13.9238H0.135438C0.0465 14.607 0 15.3035 0 16.0108C0 16.7181 0.0465 17.4146 0.135438 18.0977H8.34775H8.34781V30.0653C9.64131 30.7711 11.0431 31.3026 12.5218 31.6304V18.0979V18.0978H31.8646C31.9535 17.4146 32 16.7181 32 16.0108C32 15.3035 31.9535 14.607 31.8646 13.9239Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFaroeIslands);
export default __webpack_public_path__ + "static/media/flag_faroe_islands.492be3c2e44abb8a6e2a7bb2e406957c.svg";
export { ForwardRef as ReactComponent };